import { Action } from 'redux';
import { PopOver } from 'sofa-reborn-react';

// State
export interface PopOverState {
	buildLimit: PopOver;
	disabledDrag: PopOver;
	middleModuleDrag: PopOver;
	invalidPlacement: PopOver;
	placementInformation: PopOver;
	noValidConnection: PopOver;
	unfinishedSection: PopOver;
	missingCoverSection: PopOver;
	bannerHasBeenShown: boolean;
	placementInformationHasBeenShown: boolean;
	missingCoverSectionHasBeenShown: boolean;
	buildTipHasBeenShown: boolean;
	hideBuildTip: boolean;
}

// Actions
export const SHOW_POP_OVER = 'SHOW_POP_OVER';
export const HIDE_POP_OVER = 'HIDE_POP_OVER';
export const SET_BANNER_HAS_BEEN_SHOWN = 'SET_BANNER_HAS_BEEN_SHOWN';
export const SET_PLACEMENT_INFORMATION_HAS_BEEN_SHOWN = 'SET_PLACEMENT_INFORMATION_HAS_BEEN_SHOWN';
export const SET_MISSING_COVER_SECTION_HAS_BEEN_SHOWN = 'SET_MISSING_COVER_SECTION_HAS_BEEN_SHOWN';
export const BUILD_TIP_HAS_BEEN_SHOWN = 'BUILD_TIP_HAS_BEEN_SHOWN';
export const HIDE_BUILD_TIP = 'HIDE_BUILD_TIP';

interface ShowPopOver extends Action {
	type: typeof SHOW_POP_OVER;
	value: PopOver;
}

interface HidePopOver extends Action {
	type: typeof HIDE_POP_OVER;
	value: PopOver;
}

interface SetBannerHasBeenShown extends Action {
	type: typeof SET_BANNER_HAS_BEEN_SHOWN;
	value: boolean;
}

interface SetPlacementInformationHasBeenShown extends Action {
	type: typeof SET_PLACEMENT_INFORMATION_HAS_BEEN_SHOWN;
	value: boolean;
}

interface SetMissingCoverSectionHasBeenShown extends Action {
	type: typeof SET_MISSING_COVER_SECTION_HAS_BEEN_SHOWN;
	value: boolean;
}

interface BuildTipHasBeenShown extends Action {
	type: typeof BUILD_TIP_HAS_BEEN_SHOWN;
	value: boolean;
}

interface HideBuildTip extends Action {
	type: typeof HIDE_BUILD_TIP;
	value: boolean;
}

export type PopOverStateActions =
	| ShowPopOver
	| HidePopOver
	| SetBannerHasBeenShown
	| SetPlacementInformationHasBeenShown
	| SetMissingCoverSectionHasBeenShown
	| BuildTipHasBeenShown
	| HideBuildTip;
